import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule,
	DropdownModule
} from 'primeng/primeng';

import { OrderTableComponent } from './order-table.component';

@NgModule({
  imports: [
    CommonModule,
	TranslateModule,
	RouterModule,
	NgbModule.forRoot(),
	DataTableModule,
	ButtonModule,
	MultiSelectModule,
	ContextMenuModule,
	DropdownModule
  ],
  declarations: [OrderTableComponent],
  exports: [OrderTableComponent]
})
export class OrderTableModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/order-table/order-table.module.ts